
export default {
  data() {
    return {
      showCookie: false,
    };
  },
  mounted() {
    const newsletterBtn = document.getElementById("newsletterBtn");

    if (newsletterBtn) {
      newsletterBtn.addEventListener("click", () => {
        this.getNewsletterCookie();
      });
    }

    this.getNewsletterCookie();
  },

  methods: {
    getNewsletterCookie() {
      setTimeout(() => {
        const newsletterCookie = this.$getCookie("newsletterCookie");

        if (newsletterCookie) {
          this.showCookie = false;
        } else {
          this.showCookie = true;
        }
      }, 300);
    },
  },
};
